import { useTranslation } from 'react-i18next';
import { Phone } from 'lucide-react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const WaitingForCall = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const callerId = searchParams.get('callerId');
  const navigate = useNavigate();

  return (
    <div className="max-w-md mx-auto p-6 space-y-6 pt-16">
      {/* Phone animation container */}
      <div className="text-center">
        <div className="relative w-32 h-32 mx-auto">
          <div className="absolute inset-0 bg-emerald-50 rounded-full animate-ping opacity-25"></div>
          <div className="relative flex items-center justify-center bg-[#2B513B] rounded-full p-6 w-full h-full">
            <Phone className="w-12 h-12 text-white" />
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold text-gray-800">{t('waitingForCall.title', 'Waiting for Hana Assistant')}</h1>
        {callerId && (
          <div className="bg-blue-50 border border-blue-100 rounded-md p-4 mt-4">
            <p className="text-md text-blue-800 font-medium">
              {t('waitingForCall.phoneNumber', 'You will receive a call from: +{{number}}', { number: callerId })}
            </p>
          </div>
        )}
        <div className="flex items-center justify-center text-sm text-gray-600">
          <span>Call completed?</span>
          <span onClick={() => navigate('/')} className="text-blue-500 cursor-pointer ml-2 underline hover:text-blue-700 transition duration-200">
            Go to Dashboard
          </span>
        </div>
      </div>
    </div>
  );
};

export default WaitingForCall;
